import { createSlice } from '@reduxjs/toolkit';

import { ContractorServiceMapViewState } from 'common/types';
import { GRID_NAME } from 'common/types/datagrid';

const defaultState: ContractorServiceMapViewState = {
    activeTab: 0,
    initialized: false,
    searchFilters: [],
    advancedFilters: {},
    polygon: null,
    showOrderingEnabledOnly: false,
    contractorCompanyForTeamMembers: null,
    teamMembersForContractorCompany: [],
    tradeTypesForContractorCompany: null,
    searchType: {
        id: 'CONTRACTOR',
        display: 'Contractor',
    },
    searchQuery: {
        metadata: {
            from: 0,
            size: 30,
            resultTypes: [
                'details',
                'phoneContacts',
                'tradeTypes',
                'serviceTypes',
            ],
            sortBy: ['contractorName'],
        },
        search: {},
    },
    searchText: '',
    gridName: GRID_NAME.ADMIN_CONTRACTOR,
};

export const contractorServiceMapViewSlice = createSlice({
    name: 'contractorServiceMap',
    initialState: defaultState,
    reducers: {
        resetContractorServiceMapStore: () => {
            return defaultState;
        },
        resetAdvancedFilters: (state, action) => {
            return {
                ...state,
                advancedFilters: {},
            };
        },
        resetSearchFilters: state => {
            return {
                ...state,
                searchFilters: [],
                teamMembersForContractorCompany: [],
            };
        },
        initializeFilters: (state, action) => {
            const { initialized } = action.payload;
            return {
                ...state,
                initialized,
            };
        },
        loadSavedView: (state, action) => {
            const { selectedView } = action.payload;
            return {
                ...state,
                ...selectedView,
            };
        },
        setActiveTab: (state, action) => {
            const { activeTab } = action.payload;
            return {
                ...state,
                activeTab,
            };
        },
        setSearchFilters: (state, action) => {
            const { searchFilters } = action.payload;
            return {
                ...state,
                searchFilters,
            };
        },
        setAdvancedFilters: (state, action) => {
            const { advancedFilters } = action.payload;
            return {
                ...state,
                advancedFilters,
            };
        },
        setShowOrderingEnabledOnly: (state, action) => {
            return {
                ...state,
                showOrderingEnabledOnly: action.payload,
            };
        },
        setContractorCompanyForTeamMembers: (state, action) => {
            return {
                ...state,
                contractorCompanyForTeamMembers: action.payload,
            };
        },
        setTeamMembersForContractorCompany: (state, action) => {
            return {
                ...state,
                teamMembersForContractorCompany: action.payload,
            };
        },
        setTradeTypesForContractorCompany: (state, action) => {
            return {
                ...state,
                tradeTypesForContractorCompany: action.payload,
            };
        },
        setSearchType: (state, action) => {
            return {
                ...state,
                searchType: action.payload,
            };
        },
        setSearchQuery: (state, action) => {
            return {
                ...state,
                searchQuery: action.payload,
            };
        },
        setSearchText: (state, action) => {
            return {
                ...state,
                searchText: action.payload,
            };
        },
        setPolygon: (state, action) => {
            return {
                ...state,
                polygon: action.payload,
            };
        },
    },
});

export const {
    resetContractorServiceMapStore,
    resetAdvancedFilters,
    resetSearchFilters,
    initializeFilters,
    loadSavedView,
    setActiveTab,
    setPolygon,
    setSearchFilters,
    setAdvancedFilters,
    setShowOrderingEnabledOnly,
    setContractorCompanyForTeamMembers,
    setTeamMembersForContractorCompany,
    setTradeTypesForContractorCompany,
    setSearchText,
    setSearchQuery,
    setSearchType,
} = contractorServiceMapViewSlice.actions;

export default contractorServiceMapViewSlice.reducer;
